
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3ro6F", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $3gadb = parcelRequire("3gadb");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");








var $3654r = parcelRequire("3654r");

















var $gxtzC = parcelRequire("gxtzC");


var $1Whri = parcelRequire("1Whri");


var $ee7An = parcelRequire("ee7An");





var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");


var $4sMkA = parcelRequire("4sMkA");

const $bd15777e6f419ea7$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bd15777e6f419ea7$var$noop = (0, $ee7An.default);
const $bd15777e6f419ea7$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc",
    rootRefresh: "_vchhusvi _4t3i1k8s",
    rootT26Shape: "_2rkolb4i",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    withTruncation: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $bd15777e6f419ea7$var$unboundedStyles = {
    iconWrapperSmall: "_w8l57vkz _17527vkz",
    iconWrapper: "_syaz1cv2"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $bd15777e6f419ea7$var$Step = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(111);
    let analyticsContext;
    let ariaCurrent;
    let ariaDescribedBy;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let elemBefore;
    let href;
    let iconAfter;
    let iconBefore;
    let onBlur;
    let onFocus;
    let onMouseDown;
    let onMouseMove;
    let onMouseOut;
    let onMouseOver;
    let rest;
    let t1;
    let target;
    let testId;
    let title;
    let triggerProps;
    let truncationWidth;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t1, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent, "aria-describedby": ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaCurrent;
        $[3] = ariaDescribedBy;
        $[4] = ariaLabel;
        $[5] = ariaLabelledBy;
        $[6] = children;
        $[7] = elemBefore;
        $[8] = href;
        $[9] = iconAfter;
        $[10] = iconBefore;
        $[11] = onBlur;
        $[12] = onFocus;
        $[13] = onMouseDown;
        $[14] = onMouseMove;
        $[15] = onMouseOut;
        $[16] = onMouseOver;
        $[17] = rest;
        $[18] = t1;
        $[19] = target;
        $[20] = testId;
        $[21] = title;
        $[22] = triggerProps;
        $[23] = truncationWidth;
    } else {
        analyticsContext = $[1];
        ariaCurrent = $[2];
        ariaDescribedBy = $[3];
        ariaLabel = $[4];
        ariaLabelledBy = $[5];
        children = $[6];
        elemBefore = $[7];
        href = $[8];
        iconAfter = $[9];
        iconBefore = $[10];
        onBlur = $[11];
        onFocus = $[12];
        onMouseDown = $[13];
        onMouseMove = $[14];
        onMouseOut = $[15];
        onMouseOver = $[16];
        rest = $[17];
        t1 = $[18];
        target = $[19];
        testId = $[20];
        title = $[21];
        triggerProps = $[22];
        truncationWidth = $[23];
    }
    const onClickProvided = t1 === undefined ? $bd15777e6f419ea7$var$noop : t1;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $4sMkA.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    let t2;
    if ($[24] !== analyticsContext || $[25] !== onClickProvided) {
        t2 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$bd15777e6f419ea7$var$analyticsAttributes
        };
        $[24] = analyticsContext;
        $[25] = onClickProvided;
        $[26] = t2;
    } else t2 = $[26];
    const handleClick = (0, $gxtzC.usePlatformLeafEventHandler)(t2);
    let t3;
    if ($[27] !== handleClick || $[28] !== triggerProps) {
        t3 = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        $[27] = handleClick;
        $[28] = triggerProps;
        $[29] = t3;
    } else t3 = $[29];
    const handleTriggerClick = t3;
    const controlRef = (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") ? ref : undefined;
    const textRef = (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") ? undefined : ref;
    let t4;
    if ($[30] !== isSmall || $[31] !== resolvedElemBefore || $[32] !== testId) {
        t4 = resolvedElemBefore && /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $gMc0m.default)([
                $bd15777e6f419ea7$var$styles.iconWrapper,
                $bd15777e6f419ea7$var$unboundedStyles.iconWrapper,
                (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $bd15777e6f419ea7$var$styles.iconWrapperExternal,
                isSmall && $bd15777e6f419ea7$var$styles.iconWrapperExternalSmall,
                isSmall && $bd15777e6f419ea7$var$unboundedStyles.iconWrapperSmall
            ])
        }, resolvedElemBefore);
        $[30] = isSmall;
        $[31] = resolvedElemBefore;
        $[32] = testId;
        $[33] = t4;
    } else t4 = $[33];
    const iconElement = t4;
    let t5;
    if ($[34] !== isSmall || $[35] !== resolvedElemBefore) {
        t5 = !(0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && !isSmall && resolvedElemBefore;
        $[34] = isSmall;
        $[35] = resolvedElemBefore;
        $[36] = t5;
    } else t5 = $[36];
    let t6;
    if ($[37] !== iconElement || $[38] !== isSmall) {
        t6 = !(0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && isSmall && iconElement;
        $[37] = iconElement;
        $[38] = isSmall;
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== truncationWidth) {
        t7 = (0, $gMc0m.default)([
            $bd15777e6f419ea7$var$styles.text,
            truncationWidth != null && (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $bd15777e6f419ea7$var$styles.textWithTruncation
        ]);
        $[40] = truncationWidth;
        $[41] = t7;
    } else t7 = $[41];
    let t8;
    if ($[42] !== children || $[43] !== t7 || $[44] !== textRef) {
        t8 = /*#__PURE__*/ $42omo.createElement("span", {
            ref: textRef,
            className: t7
        }, children);
        $[42] = children;
        $[43] = t7;
        $[44] = textRef;
        $[45] = t8;
    } else t8 = $[45];
    let t9;
    if ($[46] !== iconAfter || $[47] !== t5 || $[48] !== t6 || $[49] !== t8) {
        t9 = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, t5, t6, t8, iconAfter);
        $[46] = iconAfter;
        $[47] = t5;
        $[48] = t6;
        $[49] = t8;
        $[50] = t9;
    } else t9 = $[50];
    const content = t9;
    if (href) {
        let t10;
        if ($[51] !== iconElement) {
            t10 = (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
            $[51] = iconElement;
            $[52] = t10;
        } else t10 = $[52];
        const t11 = controlRef;
        const t12 = triggerProps?.onMouseOver ?? onMouseOver;
        const t13 = triggerProps?.onMouseOut ?? onMouseOut;
        const t14 = triggerProps?.onMouseMove ?? onMouseMove;
        const t15 = triggerProps?.onMouseDown ?? onMouseDown;
        const t16 = triggerProps?.onFocus ?? onFocus;
        const t17 = triggerProps?.onBlur ?? onBlur;
        const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
        let t19;
        if ($[53] !== isSmall || $[54] !== truncationWidth) {
            t19 = (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, isSmall && $bd15777e6f419ea7$var$styles.rootSmall, (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $bd15777e6f419ea7$var$styles.rootRefresh, truncationWidth != null && (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $bd15777e6f419ea7$var$styles.withTruncation, truncationWidth == null && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)("platform-dst-shape-theme-default") && $bd15777e6f419ea7$var$styles.rootT26Shape);
            $[53] = isSmall;
            $[54] = truncationWidth;
            $[55] = t19;
        } else t19 = $[55];
        let t20;
        if ($[56] !== truncationWidth) {
            t20 = {
                maxWidth: truncationWidth
            };
            $[56] = truncationWidth;
            $[57] = t20;
        } else t20 = $[57];
        let t21;
        if ($[58] !== ariaCurrent || $[59] !== ariaLabel || $[60] !== ariaLabelledBy || $[61] !== content || $[62] !== handleTriggerClick || $[63] !== href || $[64] !== rest || $[65] !== t11 || $[66] !== t12 || $[67] !== t13 || $[68] !== t14 || $[69] !== t15 || $[70] !== t16 || $[71] !== t17 || $[72] !== t18 || $[73] !== t19 || $[74] !== t20 || $[75] !== target || $[76] !== testId || $[77] !== title) {
            t21 = /*#__PURE__*/ $42omo.createElement((0, $auNCB.default), {
                ...rest,
                ref: t11,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                href: href,
                onClick: handleTriggerClick,
                onMouseOver: t12,
                onMouseOut: t13,
                onMouseMove: t14,
                onMouseDown: t15,
                onFocus: t16,
                onBlur: t17,
                "aria-describedby": t18,
                target: target,
                testId: testId,
                title: title,
                xcss: t19,
                style: t20
            }, content);
            $[58] = ariaCurrent;
            $[59] = ariaLabel;
            $[60] = ariaLabelledBy;
            $[61] = content;
            $[62] = handleTriggerClick;
            $[63] = href;
            $[64] = rest;
            $[65] = t11;
            $[66] = t12;
            $[67] = t13;
            $[68] = t14;
            $[69] = t15;
            $[70] = t16;
            $[71] = t17;
            $[72] = t18;
            $[73] = t19;
            $[74] = t20;
            $[75] = target;
            $[76] = testId;
            $[77] = title;
            $[78] = t21;
        } else t21 = $[78];
        let t22;
        if ($[79] !== t10 || $[80] !== t21) {
            t22 = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, t10, t21);
            $[79] = t10;
            $[80] = t21;
            $[81] = t22;
        } else t22 = $[81];
        return t22;
    }
    let t10;
    if ($[82] !== iconElement) {
        t10 = (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
        $[82] = iconElement;
        $[83] = t10;
    } else t10 = $[83];
    const t11 = controlRef;
    const t12 = triggerProps?.onMouseOver ?? onMouseOver;
    const t13 = triggerProps?.onMouseOut ?? onMouseOut;
    const t14 = triggerProps?.onMouseMove ?? onMouseMove;
    const t15 = triggerProps?.onMouseDown ?? onMouseDown;
    const t16 = triggerProps?.onFocus ?? onFocus;
    const t17 = triggerProps?.onBlur ?? onBlur;
    const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
    let t19;
    if ($[84] !== isSmall || $[85] !== truncationWidth) {
        t19 = (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, isSmall && $bd15777e6f419ea7$var$styles.rootSmall, (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $bd15777e6f419ea7$var$styles.rootRefresh, truncationWidth != null && (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $bd15777e6f419ea7$var$styles.withTruncation, truncationWidth == null && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)("platform-dst-shape-theme-default") && $bd15777e6f419ea7$var$styles.rootT26Shape);
        $[84] = isSmall;
        $[85] = truncationWidth;
        $[86] = t19;
    } else t19 = $[86];
    let t20;
    if ($[87] !== truncationWidth) {
        t20 = {
            maxWidth: truncationWidth
        };
        $[87] = truncationWidth;
        $[88] = t20;
    } else t20 = $[88];
    let t21;
    if ($[89] !== ariaCurrent || $[90] !== ariaLabel || $[91] !== ariaLabelledBy || $[92] !== content || $[93] !== handleTriggerClick || $[94] !== rest || $[95] !== t11 || $[96] !== t12 || $[97] !== t13 || $[98] !== t14 || $[99] !== t15 || $[100] !== t16 || $[101] !== t17 || $[102] !== t18 || $[103] !== t19 || $[104] !== t20 || $[105] !== testId || $[106] !== title) {
        t21 = /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            ...rest,
            ref: t11,
            "aria-current": ariaCurrent,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            onClick: handleTriggerClick,
            onMouseOver: t12,
            onMouseOut: t13,
            onMouseMove: t14,
            onMouseDown: t15,
            onFocus: t16,
            onBlur: t17,
            "aria-describedby": t18,
            testId: testId,
            title: title,
            xcss: t19,
            style: t20
        }, content);
        $[89] = ariaCurrent;
        $[90] = ariaLabel;
        $[91] = ariaLabelledBy;
        $[92] = content;
        $[93] = handleTriggerClick;
        $[94] = rest;
        $[95] = t11;
        $[96] = t12;
        $[97] = t13;
        $[98] = t14;
        $[99] = t15;
        $[100] = t16;
        $[101] = t17;
        $[102] = t18;
        $[103] = t19;
        $[104] = t20;
        $[105] = testId;
        $[106] = title;
        $[107] = t21;
    } else t21 = $[107];
    let t22;
    if ($[108] !== t10 || $[109] !== t21) {
        t22 = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, t10, t21);
        $[108] = t10;
        $[109] = t21;
        $[110] = t22;
    } else t22 = $[110];
    return t22;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $bd15777e6f419ea7$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $4sMkA.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    const handleClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bd15777e6f419ea7$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        triggerProps?.onClick?.(event);
        handleClick(event);
    };
    const controlRef = (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $gMc0m.default)([
            $bd15777e6f419ea7$var$styles.iconWrapper,
            $bd15777e6f419ea7$var$unboundedStyles.iconWrapper,
            (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $bd15777e6f419ea7$var$styles.iconWrapperExternal,
            isSmall && $bd15777e6f419ea7$var$styles.iconWrapperExternalSmall,
            isSmall && $bd15777e6f419ea7$var$unboundedStyles.iconWrapperSmall
        ])
    }, resolvedElemBefore);
    const content = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, !(0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore, !(0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && isSmall && iconElement, /*#__PURE__*/ $42omo.createElement("span", {
        ref: textRef,
        className: (0, $gMc0m.default)([
            $bd15777e6f419ea7$var$styles.text,
            truncationWidth != null && (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $bd15777e6f419ea7$var$styles.textWithTruncation
        ])
    }, children), iconAfter);
    if (href) return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && iconElement, /*#__PURE__*/ $42omo.createElement((0, $auNCB.default), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        href: href,
        onClick: handleTriggerClick,
        onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
        onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
        onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
        onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
        onFocus: triggerProps?.onFocus ?? onFocus,
        onBlur: triggerProps?.onBlur ?? onBlur,
        "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
        target: target,
        testId: testId,
        title: title,
        xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
        (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, isSmall && $bd15777e6f419ea7$var$styles.rootSmall, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $bd15777e6f419ea7$var$styles.rootRefresh, truncationWidth != null && (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $bd15777e6f419ea7$var$styles.withTruncation, truncationWidth == null && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        }
    }, content));
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && iconElement, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: handleTriggerClick,
        onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
        onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
        onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
        onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
        onFocus: triggerProps?.onFocus ?? onFocus,
        onBlur: triggerProps?.onBlur ?? onBlur,
        "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
        testId: testId,
        title: title,
        xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
        (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, isSmall && $bd15777e6f419ea7$var$styles.rootSmall, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $bd15777e6f419ea7$var$styles.rootRefresh, truncationWidth != null && (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $bd15777e6f419ea7$var$styles.withTruncation, truncationWidth == null && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        }
    }, content));
});
var $bd15777e6f419ea7$export$2e2bcd8739ae039 = $bd15777e6f419ea7$var$Step;


const $553d1fa16a0fec63$var$itemWrapperStyles = null;
const $553d1fa16a0fec63$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(30);
    const { analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent } = t0;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let t1;
    if ($[0] !== analyticsContext || $[1] !== ariaCurrent || $[2] !== ariaLabel || $[3] !== ariaLabelledBy || $[4] !== href || $[5] !== iconAfter || $[6] !== iconBefore || $[7] !== onClick || $[8] !== resolvedElemBefore || $[9] !== stepRef || $[10] !== target || $[11] !== testId || $[12] !== text || $[13] !== title || $[14] !== truncationWidth) {
        t1 = (triggerProps)=>{
            const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
            return /*#__PURE__*/ $42omo.createElement((0, $bd15777e6f419ea7$export$2e2bcd8739ae039), {
                ref: tooltipRef ? (0, $3654r.default)([
                    stepRef,
                    tooltipRef
                ]) : stepRef,
                analyticsContext: analyticsContext,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-current": ariaCurrent,
                elemBefore: resolvedElemBefore,
                href: href,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                onClick: onClick,
                target: target,
                testId: testId,
                title: title,
                triggerProps: triggerProps ? tooltipTriggerProps : undefined,
                truncationWidth: truncationWidth
            }, text);
        };
        $[0] = analyticsContext;
        $[1] = ariaCurrent;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = href;
        $[5] = iconAfter;
        $[6] = iconBefore;
        $[7] = onClick;
        $[8] = resolvedElemBefore;
        $[9] = stepRef;
        $[10] = target;
        $[11] = testId;
        $[12] = text;
        $[13] = title;
        $[14] = truncationWidth;
        $[15] = t1;
    } else t1 = $[15];
    const renderStep = t1;
    let t2;
    if ($[16] !== renderStep) {
        t2 = renderStep();
        $[16] = renderStep;
        $[17] = t2;
    } else t2 = $[17];
    const step = t2;
    let t3;
    if ($[18] !== xcss) {
        t3 = (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _2lx2vrvc _1wpz1h6o _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1q9y _14rn1rpy _aetr1n76 _8yoa1h6o",
            xcss
        ]);
        $[18] = xcss;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    if ($[20] !== onTooltipShown || $[21] !== renderStep || $[22] !== shouldShowTooltip || $[23] !== step || $[24] !== text) {
        t4 = shouldShowTooltip ? /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown
        }, renderStep) : step;
        $[20] = onTooltipShown;
        $[21] = renderStep;
        $[22] = shouldShowTooltip;
        $[23] = step;
        $[24] = text;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== ref || $[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement("li", {
            ref: ref,
            className: t3
        }, t4);
        $[26] = ref;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ $42omo.createElement((0, $bd15777e6f419ea7$export$2e2bcd8739ae039), {
            ref: tooltipRef ? (0, $3654r.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth
        }, text);
    };
    const step = renderStep();
    return /*#__PURE__*/ $42omo.createElement("li", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _2lx2vrvc _1wpz1h6o _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1q9y _14rn1rpy _aetr1n76 _8yoa1h6o",
            xcss
        ])
    }, shouldShowTooltip ? /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, renderStep) : step);
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $553d1fa16a0fec63$export$2e2bcd8739ae039 = $553d1fa16a0fec63$var$BreadcrumbsItemBase;
















var $eEA8O = parcelRequire("eEA8O");







const $b9cd9c632c3988d9$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $b9cd9c632c3988d9$var$noop = (0, $ee7An.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $b9cd9c632c3988d9$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(24);
    let analyticsContext;
    let component;
    let iconAfter;
    let iconBefore;
    let props;
    let t1;
    let t2;
    let t3;
    let target;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, component: component, hasOverflow: t1, href: t2, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t3, target: target, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = component;
        $[3] = iconAfter;
        $[4] = iconBefore;
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = target;
        $[10] = testId;
    } else {
        analyticsContext = $[1];
        component = $[2];
        iconAfter = $[3];
        iconBefore = $[4];
        props = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        target = $[9];
        testId = $[10];
    }
    const hasOverflow = t1 === undefined ? true : t1;
    const href = t2 === undefined ? "#" : t2;
    const onClickProvided = t3 === undefined ? $b9cd9c632c3988d9$var$noop : t3;
    let t4;
    if ($[11] !== analyticsContext || $[12] !== onClickProvided) {
        t4 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$b9cd9c632c3988d9$var$analyticsAttributes
        };
        $[11] = analyticsContext;
        $[12] = onClickProvided;
        $[13] = t4;
    } else t4 = $[13];
    const handleClicked = (0, $gxtzC.usePlatformLeafEventHandler)(t4);
    const resolvedIconAfter = (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") ? undefined : hasOverflow ? undefined : iconAfter;
    const t5 = hasOverflow ? undefined : iconBefore;
    let t6;
    if ($[14] !== component || $[15] !== handleClicked || $[16] !== href || $[17] !== props || $[18] !== ref || $[19] !== resolvedIconAfter || $[20] !== t5 || $[21] !== target || $[22] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: resolvedIconAfter,
            iconBefore: t5,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
        $[14] = component;
        $[15] = handleClicked;
        $[16] = href;
        $[17] = props;
        $[18] = ref;
        $[19] = resolvedIconAfter;
        $[20] = t5;
        $[21] = target;
        $[22] = testId;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $b9cd9c632c3988d9$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$b9cd9c632c3988d9$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $b9cd9c632c3988d9$export$2e2bcd8739ae039 = $b9cd9c632c3988d9$var$StepOld;



var $F1g0V = parcelRequire("F1g0V");

const $5c3d9d5d7ce5effd$var$itemWrapperStyles = null;
const $5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE = 24;
const $5c3d9d5d7ce5effd$var$staticItemStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithoutTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$BreadcrumbsItem = /*#__PURE__*/ (0, $42omo.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $42omo.useState)(null);
    const setStepRef = (0, $42omo.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $F1g0V.default)(truncationWidth, stepElement, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') ? 0 : iconWidthAllowance);
    if (!component && (0, $dh538.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ $42omo.createElement((0, $553d1fa16a0fec63$export$2e2bcd8739ae039), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ $42omo.createElement((0, $bd15777e6f419ea7$export$2e2bcd8739ae039), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest
    }, text) : /*#__PURE__*/ $42omo.createElement((0, $b9cd9c632c3988d9$export$2e2bcd8739ae039), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $gMc0m.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ])
    }, text);
    return /*#__PURE__*/ $42omo.createElement("li", {
        ref: _overflowRef,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _4cvr1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ])
    }, shouldShowTooltip ? /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c3d9d5d7ce5effd$export$2e2bcd8739ae039 = $5c3d9d5d7ce5effd$var$BreadcrumbsItem;
module.exports["default"] = $5c3d9d5d7ce5effd$export$2e2bcd8739ae039;

});

parcelRegister("kGnTD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $hTKp4 = parcelRequire("hTKp4");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");














var $1qfLF = parcelRequire("1qfLF");








var $1bY7o = parcelRequire("1bY7o");





var $3gadb = parcelRequire("3gadb");


var $4sMkA = parcelRequire("4sMkA");


var $F1g0V = parcelRequire("F1g0V");

const $72c338a89271cf4b$var$COPY_RESET_DELAY_MS = 2000;
const $72c338a89271cf4b$var$ICON_WIDTH_ESTIMATE = 24;
const $72c338a89271cf4b$var$VAR_CURRENT_ITEM_TRUNCATION_WIDTH = '--breadcrumbs-current-item-max-width';
const $72c338a89271cf4b$var$unboundedStyles = {
    container: "_zulp1b66 _2rko12b0 _1rjcv77o _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k8s _1ql7kb7n",
    interactiveContainer: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8fhey _1e0c116y _4cvr1h6o _vchhusvi _syazi7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _9h8hi7uo",
    interactiveContainerSmall: "_11c8wadc",
    interactiveContainerLegacy: "_4t3i1k8s",
    interactiveContainerWithTruncation: "_1ul9idpf _p12fmvrb _1o9zkb7n",
    itemWrapper: "_1e0c1txw _vchhusvi _p12f1osq _4cvr1h6o _1wpz1h6o _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
    copyButtonWrapper: "_1e0c116y _tzy4idpf _gwqekb7n _1mygkb7n",
    iconWrapper: "_syaz1cv2",
    iconWrapperSmall: "_w8l57vkz _17527vkz"
};
const $72c338a89271cf4b$var$styles = {
    iconWrapper: "_1reo15vq _18m915vq _1e0c116y _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    iconWrapperExternal: "_12l2v77o",
    iconWrapperExternalSmall: "_12l2ze3t",
    text: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textSmall: "_11c8wadc _1reo15vq _18m915vq _syazi7uo _1bto1l2s _o5721q9c",
    textWithTruncation: "_1ul9idpf _p12f1osq _1o9zkb7n"
};
const $72c338a89271cf4b$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { text: text, href: href, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef } = t0;
    const isSmall = (0, $4sMkA.useBreadcrumbsSize)() === "small";
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $42omo.useState)(false);
    const [linkElement, setLinkElement] = (0, $42omo.useState)(null);
    const resetTimerRef = (0, $42omo.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (element)=>{
            setLinkElement(element);
        };
        $[0] = t1;
    } else t1 = $[0];
    const setLinkRef = t1;
    const [, shouldShowTooltip] = (0, $F1g0V.default)(truncationWidth, linkElement, (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") ? 0 : resolvedElemBefore ? $72c338a89271cf4b$var$ICON_WIDTH_ESTIMATE : 0);
    let t2;
    if ($[1] !== href || $[2] !== onCopyLink) {
        t2 = ()=>{
            if (!navigator.clipboard) return;
            const url = new URL(href, window.location.href).href;
            navigator.clipboard.writeText(url).then(()=>{
                setCopied(true);
                onCopyLink?.();
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
                resetTimerRef.current = setTimeout(()=>{
                    setCopied(false);
                }, $72c338a89271cf4b$var$COPY_RESET_DELAY_MS);
            }, (0, $ee7An.default));
        };
        $[1] = href;
        $[2] = onCopyLink;
        $[3] = t2;
    } else t2 = $[3];
    const handleCopy = t2;
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>()=>{
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            };
        t4 = [];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== isSmall || $[7] !== resolvedElemBefore || $[8] !== testId) {
        t5 = resolvedElemBefore && /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $gMc0m.default)([
                $72c338a89271cf4b$var$styles.iconWrapper,
                $72c338a89271cf4b$var$unboundedStyles.iconWrapper,
                (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $72c338a89271cf4b$var$styles.iconWrapperExternal,
                isSmall && $72c338a89271cf4b$var$styles.iconWrapperExternalSmall,
                isSmall && $72c338a89271cf4b$var$unboundedStyles.iconWrapperSmall
            ])
        }, resolvedElemBefore);
        $[6] = isSmall;
        $[7] = resolvedElemBefore;
        $[8] = testId;
        $[9] = t5;
    } else t5 = $[9];
    const iconElement = t5;
    const t6 = isSmall && $72c338a89271cf4b$var$styles.textSmall;
    const t7 = !isSmall && $72c338a89271cf4b$var$styles.text;
    const t8 = truncationWidth && $72c338a89271cf4b$var$styles.textWithTruncation;
    let t9;
    if ($[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
        t9 = (0, $gMc0m.default)([
            t6,
            t7,
            t8
        ]);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t9 || $[15] !== text) {
        t10 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t9
        }, text);
        $[14] = t9;
        $[15] = text;
        $[16] = t10;
    } else t10 = $[16];
    const textElement = t10;
    let t11;
    if ($[17] !== href || $[18] !== iconElement || $[19] !== isSmall || $[20] !== testId || $[21] !== textElement || $[22] !== truncationWidth) {
        t11 = (triggerProps)=>{
            const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
            return /*#__PURE__*/ $42omo.createElement("a", {
                href: href,
                "aria-current": "page",
                "data-testid": testId,
                ref: tooltipRef ? (0, $3654r.default)([
                    setLinkRef,
                    tooltipRef
                ]) : setLinkRef,
                style: truncationWidth ? {
                    "--breadcrumbs-current-item-max-width": `${truncationWidth}px`
                } : undefined,
                ...tooltipTriggerProps,
                className: (0, $gMc0m.default)([
                    $72c338a89271cf4b$var$unboundedStyles.interactiveContainer,
                    !(0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && $72c338a89271cf4b$var$unboundedStyles.interactiveContainerLegacy,
                    isSmall && $72c338a89271cf4b$var$unboundedStyles.interactiveContainerSmall,
                    truncationWidth && $72c338a89271cf4b$var$unboundedStyles.interactiveContainerWithTruncation
                ])
            }, !(0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && iconElement, textElement);
        };
        $[17] = href;
        $[18] = iconElement;
        $[19] = isSmall;
        $[20] = testId;
        $[21] = textElement;
        $[22] = truncationWidth;
        $[23] = t11;
    } else t11 = $[23];
    const renderLink = t11;
    const t12 = copied ? "Copied!" : "Copy link";
    let t13;
    if ($[24] !== copied || $[25] !== handleCopy || $[26] !== testId) {
        t13 = (tooltipProps)=>/*#__PURE__*/ $42omo.createElement("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $gMc0m.default)([
                    $72c338a89271cf4b$var$unboundedStyles.copyButtonWrapper
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...tooltipProps,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                isTooltipDisabled: true,
                label: copied ? "Link copied" : "Copy link",
                onClick: handleCopy,
                spacing: "compact",
                testId: testId && `${testId}--copy-link`
            }));
        $[24] = copied;
        $[25] = handleCopy;
        $[26] = testId;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== t12 || $[29] !== t13) {
        t14 = /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
            content: t12,
            position: "bottom"
        }, t13);
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    const copyButton = t14;
    let t15;
    let t16;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $gMc0m.default)([
            $72c338a89271cf4b$var$unboundedStyles.itemWrapper
        ]);
        t16 = (0, $gMc0m.default)([
            $72c338a89271cf4b$var$unboundedStyles.container
        ]);
        $[31] = t15;
        $[32] = t16;
    } else {
        t15 = $[31];
        t16 = $[32];
    }
    let t17;
    if ($[33] !== iconElement) {
        t17 = (0, $dh538.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
        $[33] = iconElement;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] !== onTooltipShown || $[36] !== renderLink || $[37] !== shouldShowTooltip || $[38] !== text) {
        t18 = shouldShowTooltip ? /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown
        }, renderLink) : renderLink();
        $[35] = onTooltipShown;
        $[36] = renderLink;
        $[37] = shouldShowTooltip;
        $[38] = text;
        $[39] = t18;
    } else t18 = $[39];
    let t19;
    if ($[40] !== copyButton || $[41] !== t17 || $[42] !== t18) {
        t19 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t16
        }, t17, t18, copyButton);
        $[40] = copyButton;
        $[41] = t17;
        $[42] = t18;
        $[43] = t19;
    } else t19 = $[43];
    let t20;
    if ($[44] !== _overflowRef || $[45] !== t19) {
        t20 = /*#__PURE__*/ $42omo.createElement("li", {
            ref: _overflowRef,
            "data-breadcrumbs-current-item": true,
            className: t15
        }, t19);
        $[44] = _overflowRef;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    return t20;
} : ({ text: text, href: href, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $4sMkA.useBreadcrumbsSize)() === 'small';
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $42omo.useState)(false);
    const [linkElement, setLinkElement] = (0, $42omo.useState)(null);
    const resetTimerRef = (0, $42omo.useRef)(null);
    const setLinkRef = (0, $42omo.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $F1g0V.default)(truncationWidth, linkElement, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $72c338a89271cf4b$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $42omo.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink?.();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $72c338a89271cf4b$var$COPY_RESET_DELAY_MS);
        }, (0, $ee7An.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $42omo.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $gMc0m.default)([
            $72c338a89271cf4b$var$styles.iconWrapper,
            $72c338a89271cf4b$var$unboundedStyles.iconWrapper,
            (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $72c338a89271cf4b$var$styles.iconWrapperExternal,
            isSmall && $72c338a89271cf4b$var$styles.iconWrapperExternalSmall,
            isSmall && $72c338a89271cf4b$var$unboundedStyles.iconWrapperSmall
        ])
    }, resolvedElemBefore);
    const textElement = /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            isSmall && $72c338a89271cf4b$var$styles.textSmall,
            !isSmall && $72c338a89271cf4b$var$styles.text,
            truncationWidth && $72c338a89271cf4b$var$styles.textWithTruncation
        ])
    }, text);
    const renderLink = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ $42omo.createElement("a", {
            href: href,
            "aria-current": "page",
            "data-testid": testId,
            ref: tooltipRef ? (0, $3654r.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            style: truncationWidth ? {
                '--breadcrumbs-current-item-max-width': `${truncationWidth}px`
            } : undefined,
            ...tooltipTriggerProps,
            className: (0, $gMc0m.default)([
                $72c338a89271cf4b$var$unboundedStyles.interactiveContainer,
                !(0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && $72c338a89271cf4b$var$unboundedStyles.interactiveContainerLegacy,
                isSmall && $72c338a89271cf4b$var$unboundedStyles.interactiveContainerSmall,
                truncationWidth && $72c338a89271cf4b$var$unboundedStyles.interactiveContainerWithTruncation
            ])
        }, !(0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && iconElement, textElement);
    };
    const copyButton = /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ $42omo.createElement("span", {
            "data-breadcrumbs-copy-link": true,
            "data-copied": copied || undefined,
            className: (0, $gMc0m.default)([
                $72c338a89271cf4b$var$unboundedStyles.copyButtonWrapper
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            ...tooltipProps,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            isTooltipDisabled: true,
            label: copied ? 'Link copied' : 'Copy link',
            onClick: handleCopy,
            spacing: "compact",
            testId: testId && `${testId}--copy-link`
        })));
    return /*#__PURE__*/ $42omo.createElement("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $gMc0m.default)([
            $72c338a89271cf4b$var$unboundedStyles.itemWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $72c338a89271cf4b$var$unboundedStyles.container
        ])
    }, (0, $dh538.fg)('platform_dst_breadcrumbs-refresh') && iconElement, shouldShowTooltip ? /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, renderLink) : renderLink(), copyButton));
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $72c338a89271cf4b$export$2e2bcd8739ae039 = $72c338a89271cf4b$var$BreadcrumbsCurrentItem;















var $1Whri = parcelRequire("1Whri");





var $fVUfS = parcelRequire("fVUfS");




const $7976e3e68603e041$var$noop = (0, $ee7An.default);
const $7976e3e68603e041$var$itemWrapperStyles = null;
const $7976e3e68603e041$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1wpz1h6o _1pfhze3t _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootSmall: "_11c8wadc"
};
const $7976e3e68603e041$var$EllipsisItem = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { label: label, onClick: t1, testId: testId } = t0;
    const onClick = t1 === undefined ? $7976e3e68603e041$var$noop : t1;
    const breadcrumbsSize = (0, $4sMkA.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = isSmall && $7976e3e68603e041$var$styles.rootSmall;
    let t4;
    if ($[1] !== t3) {
        t4 = (0, $1Whri.cx)($7976e3e68603e041$var$styles.root, t3);
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== label || $[4] !== onClick || $[5] !== t4 || $[6] !== testId) {
        t5 = /*#__PURE__*/ $42omo.createElement("li", {
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: t4,
            testId: testId
        }, "\u2026"));
        $[3] = label;
        $[4] = onClick;
        $[5] = t4;
        $[6] = testId;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ label: label, onClick: onClick = $7976e3e68603e041$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $4sMkA.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ $42omo.createElement("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _z4qy1rpy _15621n76 _191d1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        "aria-label": label,
        onClick: onClick,
        xcss: (0, $1Whri.cx)($7976e3e68603e041$var$styles.root, isSmall && $7976e3e68603e041$var$styles.rootSmall),
        testId: testId
    }, "\u2026"));
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7976e3e68603e041$export$2e2bcd8739ae039 = $7976e3e68603e041$var$EllipsisItem;



var $dRzoe = parcelRequire("dRzoe");

const $8dabff509d2a7ef6$export$2295e777093f3940 = (0, $dRzoe.default).Provider;


















var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $9VJDA = parcelRequire("9VJDA");

const $1b550c53457c56c4$var$groupWrapperStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $1b550c53457c56c4$var$EllipsisPopup = (0, $4pOgL.isReactCompilerActivePlatform)() ? function EllipsisPopup(t0) {
    const $ = (0, $frIzR.c)(12);
    const { collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== onClick || $[2] !== testId) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps } = t2;
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        };
        $[0] = label;
        $[1] = onClick;
        $[2] = testId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_p12f1y37"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== collapsedItems) {
        t3 = collapsedItems.map($1b550c53457c56c4$var$_temp);
        $[5] = collapsedItems;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, t3));
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
            trigger: t1,
            placement: "bottom-start"
        }, t4);
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function EllipsisPopup({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_p12f1y37"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, collapsedItems.map((item, i)=>/*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
            key: i,
            href: item.href,
            target: item.target,
            onClick: item.onClick
        }, item.text)))));
};
var $1b550c53457c56c4$export$2e2bcd8739ae039 = $1b550c53457c56c4$var$EllipsisPopup;
function $1b550c53457c56c4$var$_temp(item, i) {
    return /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
        key: i,
        href: item.href,
        target: item.target,
        onClick: item.onClick
    }, item.text);
}












var $bzNqF = parcelRequire("bzNqF");

const $bbb20e0fdee82203$export$e9c4922b2ecf808a = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useOnRevealed(callback, t0) {
    const $ = (0, $frIzR.c)(6);
    const { isExpanded: isExpanded, isDisabled: isDisabled } = t0;
    const prevExtended = (0, $bzNqF.default)(isExpanded);
    let t1;
    let t2;
    if ($[0] !== callback || $[1] !== isDisabled || $[2] !== isExpanded || $[3] !== prevExtended) {
        t1 = ()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        };
        t2 = [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ];
        $[0] = callback;
        $[1] = isDisabled;
        $[2] = isExpanded;
        $[3] = prevExtended;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
} : function useOnRevealed(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $bzNqF.default)(isExpanded);
    (0, $42omo.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
};





// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $deeec07e6c0fcb73$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $deeec07e6c0fcb73$var$useLayoutEffect = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
function $deeec07e6c0fcb73$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $deeec07e6c0fcb73$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $deeec07e6c0fcb73$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $42omo.useRef)([]);
    const containerRef = (0, $42omo.useRef)(null);
    const naturalWidths = (0, $42omo.useRef)([]);
    const naturalWidthsReady = (0, $42omo.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $42omo.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $42omo.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $deeec07e6c0fcb73$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>el?.offsetWidth ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $42omo.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $deeec07e6c0fcb73$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $deeec07e6c0fcb73$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$deeec07e6c0fcb73$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $42omo.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $42omo.useRef)(null);
    const registerContainer = (0, $42omo.useCallback)((el)=>{
        // Disconnect any existing observer
        observerRef.current?.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $42omo.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}


const $bb8be9a617eb3e67$var$defaultMaxItems = 8;
const $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $bb8be9a617eb3e67$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $bb8be9a617eb3e67$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children;
const $bb8be9a617eb3e67$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bb8be9a617eb3e67$var$noop = (0, $ee7An.default);
const $bb8be9a617eb3e67$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $bb8be9a617eb3e67$var$breadcrumbStylesOld = null;
const $bb8be9a617eb3e67$var$breadcrumbStylesNew = null;
const $bb8be9a617eb3e67$var$navStylesNew = null;
const $bb8be9a617eb3e67$var$ellipsisItemWrapperStyles = null; // items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $bb8be9a617eb3e67$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $bb8be9a617eb3e67$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $72c338a89271cf4b$export$2e2bcd8739ae039);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $bb8be9a617eb3e67$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(6);
    if ((0, $dh538.fg)("platform_dst_breadcrumbs-refresh")) {
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb8be9a617eb3e67$var$InnerBreadcrumbsNew, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props || $[4] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb8be9a617eb3e67$var$InnerBreadcrumbsOld, {
            ...props,
            ref: ref
        });
        $[3] = props;
        $[4] = ref;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : (props, ref)=>{
    if ((0, $dh538.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb8be9a617eb3e67$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb8be9a617eb3e67$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $bb8be9a617eb3e67$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(25);
    const { defaultExpanded: t0, isExpanded: isExpanded, maxItems: t1, itemsBeforeCollapse: t2, itemsAfterCollapse: t3, children: t4, testId: testId, onExpand: t5, analyticsContext: analyticsContext, label: t6, ellipsisLabel: t7, size: t8 } = props;
    const defaultExpanded = t0 === undefined ? false : t0;
    const maxItems = t1 === undefined ? $bb8be9a617eb3e67$var$defaultMaxItems : t1;
    const itemsBeforeCollapse = t2 === undefined ? 1 : t2;
    const itemsAfterCollapse = t3 === undefined ? 1 : t3;
    const children = t4 === undefined ? [] : t4;
    const providedExpanse = t5 === undefined ? $bb8be9a617eb3e67$var$noop : t5;
    const label = t6 === undefined ? $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel : t6;
    const ellipsisLabel = t7 === undefined ? $bb8be9a617eb3e67$var$defaultEllipsisLabel : t7;
    const size = t8 === undefined ? "medium" : t8;
    const [expanded, setExpanse] = (0, $42omo.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const isControlled = typeof isExpanded !== "undefined";
    const isExpansionHandled = providedExpanse !== $bb8be9a617eb3e67$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    let t9;
    if ($[0] !== itemsBeforeCollapse) {
        t9 = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll("li"));
                const interactiveElements = listItems.map($bb8be9a617eb3e67$var$_temp);
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        $[0] = itemsBeforeCollapse;
        $[1] = t9;
    } else t9 = $[1];
    const focusFirstRevealedMemoized = t9;
    const t10 = !isClickedBySpace;
    let t11;
    if ($[2] !== shouldExpand || $[3] !== t10) {
        t11 = {
            isExpanded: shouldExpand,
            isDisabled: t10
        };
        $[2] = shouldExpand;
        $[3] = t10;
        $[4] = t11;
    } else t11 = $[4];
    (0, $bbb20e0fdee82203$export$e9c4922b2ecf808a)(focusFirstRevealedMemoized, t11);
    let t12;
    if ($[5] !== isControlled || $[6] !== isExpansionHandled || $[7] !== providedExpanse) {
        t12 = (event, analyticsEvent)=>{
            if (!isControlled) setExpanse($bb8be9a617eb3e67$var$_temp2);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $hTKp4.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        };
        $[5] = isControlled;
        $[6] = isExpansionHandled;
        $[7] = providedExpanse;
        $[8] = t12;
    } else t12 = $[8];
    let t13;
    if ($[9] !== analyticsContext || $[10] !== t12) {
        t13 = {
            fn: t12,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$bb8be9a617eb3e67$var$analyticsAttributes
        };
        $[9] = analyticsContext;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    const handleExpansion = (0, $gxtzC.usePlatformLeafEventHandler)(t13);
    const childrenArray = $bb8be9a617eb3e67$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === "string") return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            "aria-current": "page"
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7976e3e68603e041$export$2e2bcd8739ae039), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    let t14;
    if ($[12] !== ref) {
        t14 = (0, $3654r.default)([
            ref,
            wrapperRef
        ]);
        $[12] = ref;
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]);
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] !== breadcrumbsItems || $[16] !== testId) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
            "data-testid": testId,
            className: t15
        }, breadcrumbsItems);
        $[15] = breadcrumbsItems;
        $[16] = testId;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== label || $[19] !== t14 || $[20] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", {
            "aria-label": label,
            ref: t14,
            tabIndex: -1
        }, t16);
        $[18] = label;
        $[19] = t14;
        $[20] = t16;
        $[21] = t17;
    } else t17 = $[21];
    let t18;
    if ($[22] !== size || $[23] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dabff509d2a7ef6$export$2295e777093f3940), {
            value: size
        }, t17);
        $[22] = size;
        $[23] = t17;
        $[24] = t18;
    } else t18 = $[24];
    return t18;
} : (props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $bb8be9a617eb3e67$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $bb8be9a617eb3e67$var$noop, analyticsContext: analyticsContext, label: label = $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $bb8be9a617eb3e67$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $42omo.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $bb8be9a617eb3e67$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $42omo.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($bb8be9a617eb3e67$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $bbb20e0fdee82203$export$e9c4922b2ecf808a)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded_0)=>!expanded_0);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $hTKp4.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$bb8be9a617eb3e67$var$analyticsAttributes
    });
    const childrenArray = $bb8be9a617eb3e67$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7976e3e68603e041$export$2e2bcd8739ae039), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dabff509d2a7ef6$export$2295e777093f3940), {
        value: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", {
        "aria-label": label,
        ref: (0, $3654r.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ])
    }, breadcrumbsItems)));
});
const $bb8be9a617eb3e67$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(17);
    const { children: t0, testId: testId, analyticsContext: analyticsContext, label: t1, ellipsisLabel: t2, size: t3 } = props;
    const children = t0 === undefined ? [] : t0;
    const label = t1 === undefined ? $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel : t1;
    const ellipsisLabel = t2 === undefined ? $bb8be9a617eb3e67$var$defaultEllipsisLabel : t2;
    const size = t3 === undefined ? "medium" : t3;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).filter($bb8be9a617eb3e67$var$_temp3);
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $deeec07e6c0fcb73$export$2e2bcd8739ae039)(itemCount);
    let t4;
    if ($[2] !== analyticsContext) {
        t4 = {
            fn: $bb8be9a617eb3e67$var$noop,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$bb8be9a617eb3e67$var$analyticsAttributes
        };
        $[2] = analyticsContext;
        $[3] = t4;
    } else t4 = $[3];
    const handleOverflowExpansion = (0, $gxtzC.usePlatformLeafEventHandler)(t4);
    const collapsedItems = Array.from(collapsedIndices).sort($bb8be9a617eb3e67$var$_temp4).map((i)=>$bb8be9a617eb3e67$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
                    key: "ellipsis",
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _vchhusvi _4cvr1h6o _2lx2vrvc _1o9zidpf _1wpz1h6o _1pfhze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1h6o _14rn1rpy _aetr1n76 _8yoa1h6o"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b550c53457c56c4$export$2e2bcd8739ae039), {
                    collapsedItems: collapsedItems,
                    label: ellipsisLabel,
                    onClick: handleOverflowExpansion,
                    testId: testId && `${testId}--breadcrumb-ellipsis`
                })));
            }
            return;
        }
        renderedItems.push($bb8be9a617eb3e67$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$bb8be9a617eb3e67$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1ul9idpf"
        ]);
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1ul9idpf _4cvr1q9y _1n261q9c _2mzuglyw _6rthidpf _1pfhidpf _12l2idpf _ahbqidpf _85i5idpf _1q51idpf _y4tiidpf _bozgidpf"
        ]);
        $[5] = t6;
    } else t6 = $[5];
    const t7 = naturalWidthsReady ? renderedItems : measureItems;
    let t8;
    if ($[6] !== registerContainer || $[7] !== t7 || $[8] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
            "data-testid": testId,
            ref: registerContainer,
            className: t6
        }, t7);
        $[6] = registerContainer;
        $[7] = t7;
        $[8] = testId;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== label || $[11] !== ref || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: t5
        }, t8);
        $[10] = label;
        $[11] = ref;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== size || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dabff509d2a7ef6$export$2295e777093f3940), {
            value: size
        }, t9);
        $[14] = size;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
} : (props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $bb8be9a617eb3e67$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $deeec07e6c0fcb73$export$2e2bcd8739ae039)(itemCount);
    const handleOverflowExpansion = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: $bb8be9a617eb3e67$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$bb8be9a617eb3e67$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$bb8be9a617eb3e67$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
                    key: "ellipsis",
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _vchhusvi _4cvr1h6o _2lx2vrvc _1o9zidpf _1wpz1h6o _1pfhze3t _1mnxv77o _1nh4u2gc _z0aiftgi _tua5idpf _1plw1h6o _14rn1rpy _aetr1n76 _8yoa1h6o"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b550c53457c56c4$export$2e2bcd8739ae039), {
                    collapsedItems: collapsedItems,
                    label: ellipsisLabel,
                    onClick: handleOverflowExpansion,
                    testId: testId && `${testId}--breadcrumb-ellipsis`
                })));
            }
            return;
        }
        renderedItems.push($bb8be9a617eb3e67$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$bb8be9a617eb3e67$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dabff509d2a7ef6$export$2295e777093f3940), {
        value: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", {
        "aria-label": label,
        ref: ref,
        tabIndex: -1,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        "data-testid": testId,
        ref: registerContainer,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1ul9idpf _4cvr1q9y _1n261q9c _2mzuglyw _6rthidpf _1pfhidpf _12l2idpf _ahbqidpf _85i5idpf _1q51idpf _y4tiidpf _bozgidpf"
        ])
    }, naturalWidthsReady ? renderedItems : measureItems)));
});
const $bb8be9a617eb3e67$var$Breadcrumbs = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(31);
    let analyticsContext;
    let children;
    let createAnalyticsEvent;
    let defaultExpanded;
    let ellipsisLabel;
    let isExpanded;
    let itemsAfterCollapse;
    let itemsBeforeCollapse;
    let label;
    let maxItems;
    let onExpand;
    let props;
    let size;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = children;
        $[3] = createAnalyticsEvent;
        $[4] = defaultExpanded;
        $[5] = ellipsisLabel;
        $[6] = isExpanded;
        $[7] = itemsAfterCollapse;
        $[8] = itemsBeforeCollapse;
        $[9] = label;
        $[10] = maxItems;
        $[11] = onExpand;
        $[12] = props;
        $[13] = size;
        $[14] = testId;
    } else {
        analyticsContext = $[1];
        children = $[2];
        createAnalyticsEvent = $[3];
        defaultExpanded = $[4];
        ellipsisLabel = $[5];
        isExpanded = $[6];
        itemsAfterCollapse = $[7];
        itemsBeforeCollapse = $[8];
        label = $[9];
        maxItems = $[10];
        onExpand = $[11];
        props = $[12];
        size = $[13];
        testId = $[14];
    }
    let t1;
    if ($[15] !== analyticsContext || $[16] !== children || $[17] !== createAnalyticsEvent || $[18] !== defaultExpanded || $[19] !== ellipsisLabel || $[20] !== isExpanded || $[21] !== itemsAfterCollapse || $[22] !== itemsBeforeCollapse || $[23] !== label || $[24] !== maxItems || $[25] !== onExpand || $[26] !== props || $[27] !== ref || $[28] !== size || $[29] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb8be9a617eb3e67$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            size: size,
            ref: ref,
            testId: testId
        });
        $[15] = analyticsContext;
        $[16] = children;
        $[17] = createAnalyticsEvent;
        $[18] = defaultExpanded;
        $[19] = ellipsisLabel;
        $[20] = isExpanded;
        $[21] = itemsAfterCollapse;
        $[22] = itemsBeforeCollapse;
        $[23] = label;
        $[24] = maxItems;
        $[25] = onExpand;
        $[26] = props;
        $[27] = ref;
        $[28] = size;
        $[29] = testId;
        $[30] = t1;
    } else t1 = $[30];
    return t1;
} : ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bb8be9a617eb3e67$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $bb8be9a617eb3e67$export$2e2bcd8739ae039 = $bb8be9a617eb3e67$var$Breadcrumbs;
function $bb8be9a617eb3e67$var$_temp(li) {
    return li.querySelector($bb8be9a617eb3e67$var$interactiveElementSelector);
}
function $bb8be9a617eb3e67$var$_temp2(expanded_0) {
    return !expanded_0;
}
function $bb8be9a617eb3e67$var$_temp3(child) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child);
}
function $bb8be9a617eb3e67$var$_temp4(a, b) {
    return a - b;
}
module.exports["default"] = $bb8be9a617eb3e67$export$2e2bcd8739ae039;

});

parcelRegister("4sMkA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $dRzoe = parcelRequire("dRzoe");

const $1946bde7f31535f7$export$c60a2bbc99661fa2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useBreadcrumbsSize() {
    return (0, $42omo.useContext)((0, $dRzoe.default));
} : function useBreadcrumbsSize() {
    return (0, $42omo.useContext)((0, $dRzoe.default));
};
module.exports["useBreadcrumbsSize"] = $1946bde7f31535f7$export$c60a2bbc99661fa2;

});

parcelRegister("F1g0V", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $7675ee682b2302ec$var$useOverflowable = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const $ = (0, $frIzR.c)(9);
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    const [hasOverflow, setOverflow] = (0, $42omo.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    let t0;
    let t1;
    if ($[0] !== buttonRefCurrent || $[1] !== iconWidthAllowance || $[2] !== shouldCheckWidth || $[3] !== truncationWidth) {
        t0 = ()=>{
            if (shouldCheckWidth) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        };
        t1 = [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance,
            shouldCheckWidth
        ];
        $[0] = buttonRefCurrent;
        $[1] = iconWidthAllowance;
        $[2] = shouldCheckWidth;
        $[3] = truncationWidth;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[6] !== hasOverflow || $[7] !== showTooltip) {
        t2 = [
            hasOverflow,
            showTooltip
        ];
        $[6] = hasOverflow;
        $[7] = showTooltip;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $42omo.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $42omo.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
};
var $7675ee682b2302ec$export$2e2bcd8739ae039 = $7675ee682b2302ec$var$useOverflowable;
module.exports["default"] = $7675ee682b2302ec$export$2e2bcd8739ae039;

});

parcelRegister("dRzoe", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $fc234ad36905dbf8$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $42omo.createContext)('medium');
var $fc234ad36905dbf8$export$2e2bcd8739ae039 = $fc234ad36905dbf8$var$BreadcrumbsSizeContext;
module.exports["default"] = $fc234ad36905dbf8$export$2e2bcd8739ae039;

});


//# sourceMappingURL=object-preview-panel.f4205474.js.map
